import { FeatureFlagService } from '../../services/feature-flag/feature-flag.service';
import { Component, OnDestroy } from '@angular/core';
import { DebugService } from 'src/app/modules/debug/services/debug/debug.service';
import { featureFlagLabels, featureflagSections } from 'src/app/data';
import { Subscription } from 'rxjs';
import { FeatureFlags } from 'src/app/shared/enums/feature-flags';

@Component({
  selector: 'htc-feature-flag-menu',
  templateUrl: './feature-flag-menu.component.html',
  styleUrls: ['./feature-flag-menu.component.scss'],
  standalone: false,
})
export class FeatureFlagMenuComponent implements OnDestroy {
  flags!: Map<string, boolean>;
  flagSectionsMap: Map<string, string[]> = new Map();
  sectionKeys: string[] = [];
  subscription = new Subscription();
  flagLabels: { [key: string]: string } = featureFlagLabels;
  gradeOptions = [
    {
      value: FeatureFlags.FORCE_PRE_K2_FLOW,
      label: 'PreK-2',
    },
    {
      value: FeatureFlags.FORCE_GRADE_3_PLUS_FLOW,
      label: '3-12',
    },
  ];

  constructor(
    public featureFlagService: FeatureFlagService,
    public debugService: DebugService
  ) {
    this.flags = new Map(featureFlagService.getFlags());
    this.flagSectionsMap = new Map(Object.entries(featureflagSections));
    this.sectionKeys = Array.from(this.flagSectionsMap.keys());
    // listen for the flag changes if setFlag, clearOverrideFlags or populateFlags called in the FeatureFlagService
    this.subscription.add(
      featureFlagService.flagsChanged.subscribe(() => {
        this.flags = new Map(featureFlagService.getFlags());
      })
    );
  }

  onCheckboxClicked(key: string): void {
    this.featureFlagService.setFlag(
      key,
      !this.featureFlagService.isFlagEnabled(key)
    );
    this.featureFlagService.saveCurrentAsOverride();
  }

  //TODO: AMR - Move this to its own service and change grade to number instead of 2 feature flags (grade-selection.service.ts) post BTS
  onGradeChange(event: Event): void {
    const value = (event.target as HTMLSelectElement).value;
    this.gradeOptions.forEach(option => {
      this.featureFlagService.setFlag(option.value, option.value === value);
    });
    this.featureFlagService.saveCurrentAsOverride();
  }

  clearOverrides(): void {
    this.featureFlagService.clearOverrideFlags();
    window.alert('Feature flag overrides wiped!');
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }
}
